import { io } from 'socket.io-client';
//const URL = 'http://192.168.0.14:3333/';
//const URL = 'http://localhost:3333/';
const URL = 'https://speed-industria-node.herokuapp.com/';
//const URL = 'https://speed-dashboard-527a8830adbf.herokuapp.com';

export const socket = io(URL);
